import * as React from "react";
import classNames from "classnames";
import AnimateHeight from "react-animate-height";
import { currentMediaQueries, Breakpoints } from "~/utils/breakpoint-utils";

export interface IShowMoreProps {
    minHeight: number;
    btnLabelShowMore?: string;
    btnLabelShowLess?: string;
    className?: string;
    disableOnBreakpoint?: Breakpoints;
}
interface IShowMoreState {
    showMoreHasOverflow: boolean;
    showMoreIsOpen: boolean;
}

class ShowMore extends React.Component<IShowMoreProps, IShowMoreState> {
    private childrenWrapper: HTMLDivElement | null;

    public state = {
        showMoreHasOverflow: true,
        showMoreIsOpen: false
    };

    public componentDidMount() {
        window.addEventListener("resize", this.handleResize.bind(this));
        this.handleResize();
    }

    public componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize.bind(this));
    }

    public handleResize() {
        const { disableOnBreakpoint, minHeight } = this.props;
        const disableOverflow = disableOnBreakpoint && currentMediaQueries[disableOnBreakpoint];
        const hasOverflow = this.childrenWrapper && this.childrenWrapper.clientHeight > minHeight;

        if (!disableOverflow && hasOverflow) {
            this.setState({ showMoreHasOverflow: true });
        } else {
            this.setState({ showMoreHasOverflow: false });
        }
    }

    private toggleMore() {
        this.setState({ showMoreIsOpen: !this.state.showMoreIsOpen });
    }

    public render() {
        const { className, minHeight, btnLabelShowLess, btnLabelShowMore, children } = this.props;
        const baseClass = "show-more";
        const containerClasses = classNames(className, baseClass, {
            [`${baseClass}--hasOverflow`]: this.state.showMoreHasOverflow,
            [`${baseClass}--isClosed`]: this.state.showMoreHasOverflow && !this.state.showMoreIsOpen
        });
        const setAnimateToMinHeight = this.state.showMoreHasOverflow && !this.state.showMoreIsOpen;
        const btnText = this.state.showMoreIsOpen ? btnLabelShowLess : btnLabelShowMore;

        return (
            <div className={containerClasses}>
                <AnimateHeight height={setAnimateToMinHeight ? minHeight : "auto"} duration={300}>
                    <div ref={node => (this.childrenWrapper = node)}>{children}</div>
                </AnimateHeight>

                <button className="show-more-button" onClick={() => this.toggleMore()}>
                    {btnText}
                </button>
            </div>
        );
    }
}

export default ShowMore;
